<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- RESERVED -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Reserved Seats</span>
                </div>
              </b-col>
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Reserved: {{webinars.length}} Live Webinars</span>
              </b-col>
            </b-row>
          </div>

            <!-- TBD classList component. -->
          <div class="div-section-body">
            <b-row v-if="rows === 0">
              <b-col class="pt-3 pb-3 pl-4 pr-4">
                No seats reserved.  Click button below to see upcoming webinars.
                <div class="mt-2 mb-2 text-center">
                  <b-button to="/upcoming">Upcoming Live CE Webinars</b-button>
                </div>
              </b-col>
            </b-row>
            <b-row v-for="row in webinars" v-bind:key="row.classId" @click.stop.prevent="gotoWebinar(row)" class="mt-3 mb-3 pointer">
              <b-col cols="4" class="text-center">
                  <b-img fluid v-bind:src="row.photo" />
                  <div v-if="!row.isWaiting" class="text-center reserved">RESERVED</div>
                  <div v-if="row.isWaiting" class="text-center waitlist">WAITLIST</div>
                  <b-button v-if="!row.isWaiting" @click.stop.prevent="gotoCancel(row.cancelCode)" variant="warning" size="sm" class="mt-2 text-center" style="z-index:100">
                    Cancel
                  </b-button>
              </b-col>
              <b-col cols="8" style="margin-left: -20px;">
                <div class="class-title">{{row.className}}</div>
                <div class="class-details">
                  {{row.speakerName}}
                  <br>{{row.sponsorCompanyName}}
                  <span class="red">
                    <br>{{row.releaseDateUTC | prettyDateTime}}
                    <br>{{row.credits}} CEU ({{row.creditName}})
                  </span>
                </div>
              </b-col>
            </b-row>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  loading: true,
  msg: 'Reserved Seats',
  blurb: '',
  webinars: [],
  studentHash: '',
  bannerAds: []
};

export default {
  name: "Seats",
  data() {
    return data;
  },
  props: { },
  computed: {
    rows() {
      return this.webinars.length
    }
  },
  methods: {
    gotoWebinar(row) {
      if (row.hasSeat || row.isWaiting) {
        this.$router.push(`/live/${row.hash}`)
      }
      else { console.log(row) }
    },
    gotoCancel(cancelCode) {
      this.$router.push(`/cancel-seat/${cancelCode}`)
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {
    this.studentHash = this.$root.getToken();
    service
      .getSeats(this.studentHash)
      .then( res => {
        if (this.debug) console.log(res);
        if (res.status && res.rowCount !== 0) {
          this.blurb = `Reserved Seats: ${res.rowCount}`
          this.webinars = res.data
        } else {
          this.blurb = "No reserved seats.";
        }
      })
      .finally(() => this.loading = false)
      .catch(e => console.log(e));
  },
  mounted() { console.log('mounted') },
  beforeDestroy() {
    console.log('destroy')
    this.loading = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Seats.vue